import { useMemo } from "react";
import "react-tippy/dist/tippy.css";
const kDefaultTooltipOptions = {
    position: "bottom",
    distance: 0,
    size: "small",
    duration: 0,
    hideDuration: 0,
    animation: "fade",
    animateFill: false
};
export const useTooltipOptions = (options) => {
    const optionsJson = JSON.stringify(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const tooltipOptions = useMemo(() => (Object.assign(Object.assign({}, kDefaultTooltipOptions), options)), [optionsJson]);
    return tooltipOptions;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLXRvb2x0aXAtb3B0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy91c2UtdG9vbHRpcC1vcHRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFHaEMsT0FBTyw0QkFBNEIsQ0FBQztBQUVwQyxNQUFNLHNCQUFzQixHQUFpQjtJQUMzQyxRQUFRLEVBQUUsUUFBUTtJQUNsQixRQUFRLEVBQUUsQ0FBQztJQUNYLElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLENBQUM7SUFDWCxZQUFZLEVBQUUsQ0FBQztJQUNmLFNBQVMsRUFBRSxNQUFNO0lBQ2pCLFdBQVcsRUFBRSxLQUFLO0NBQ25CLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLE9BQXNCLEVBQUUsRUFBRTtJQUMxRCxNQUFNLFdBQVcsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQzVDLHVEQUF1RDtJQUN2RCxNQUFNLGNBQWMsR0FBRyxPQUFPLENBQUMsR0FBRyxFQUFFLENBQUMsaUNBQU0sc0JBQXNCLEdBQUssT0FBTyxFQUFHLEVBQUUsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDO0lBQ2pHLE9BQU8sY0FBYyxDQUFDO0FBQ3hCLENBQUMsQ0FBQyJ9